export default __webpack_public_path__ + "static/media/CSSCircularBackground-light-sepia-enlarged-700px.jpg.50a46840.webp";